import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    padding: "4rem 1.5rem",
    background: "linear-gradient(to bottom, #1A1C1B, #03321A)",
    color: "white",
  },
  container: {
    maxWidth: "64rem",
    margin: "0 auto",
  },
  heading: {
    fontSize: "1.875rem",
    fontWeight: 700,
    textAlign: "center",
    marginBottom: "0.75rem",
  },
  subtext: {
    textAlign: "center",
    color: "#d1d5db",
    marginBottom: "2rem",
  },
  tabsWrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: "1rem",
    justifyContent: "center",
    marginBottom: "2rem",
  },
  tab: {
    padding: "0.5rem 1.25rem",
    borderRadius: "9999px",
    border: "1px solid white",
    transition: "all 0.3s ease",
    cursor: "pointer",
    color: "white",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "white",
      color: "black",
    },
  },
  activeTab: {
    backgroundColor: "white",
    color: "black",
  },
  faqItem: {
    backgroundColor: "transparent",
    marginBottom: "1rem",
    border: "1px solid #FFF",
    borderRadius: "0.75rem",
    overflow: "hidden",
  },
  active: {
    background: "#293E34"
  },
  questionBtn: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    padding: "32px",
    background: "transparent",
    borderRadius: "8px",
    fontWeight: 500,
    fontSize: "16px",
    transition: "background 0.2s ease",
  },
  answerText: {
    padding: "0px 32px 16px 32px",
    color: "#d1d5db",
  },
}));

export default useStyles;
